export function getConfig(state) {
  return state.config;
}

export const getGeneral =  (state) => state.config.general;